/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_Kiotviet_Not_AllowedInputs */

const vi_error_return_kiotviet_not_allowed = /** @type {(inputs: Error_Return_Kiotviet_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn tạo từ hóa đơn KiotViet phải trả hàng bên KiotViet.`)
};

/**

* @param {Error_Return_Kiotviet_Not_AllowedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_kiotviet_not_allowed = /** @type {((inputs?: Error_Return_Kiotviet_Not_AllowedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_Kiotviet_Not_AllowedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_kiotviet_not_allowed(inputs)
});